import { render, staticRenderFns } from "./configContentProductList.vue?vue&type=template&id=e8f83e46&scoped=true"
import script from "./configContentProductList.vue?vue&type=script&lang=js"
export * from "./configContentProductList.vue?vue&type=script&lang=js"
import style0 from "./configContentProductList.vue?vue&type=style&index=0&id=e8f83e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f83e46",
  null
  
)

export default component.exports